/**
 * Paleta BorisMetrics — fuente única de verdad para TS y Mantine.
 * CSS equivalente en theme/colors.css
 */
export const palette = {
  primary: '#5D737E',
  primaryHover: '#4A5F69',
  primaryLight: '#8FA8B2',
  accent: '#64B6AC',
  accentDark: '#4A9189',
  accentBg: '#E8F8F7',
  tint1: '#C0FDFB',
  cydBadgeText: '#2A6A6C',
  tint2: '#DAFFEF',
  surface: '#FCFFFD',
  surfaceCard: '#FFFFFF',
  surfacePage: '#FCFFFD',
  border: '#DDE4E7',
  textPrimary: '#1E2D35',
  textSecondary: '#5C7380',
  textMuted: '#9BAFB8',
  positive: '#1A7A4A',
  negative: '#C0392B',
  warning: '#D4860A',
  neutral: '#9BAFB8',
  chartPositiveMeta: '#5DAF7A',
  sidebarActiveBg: 'rgba(100, 182, 172, 0.15)',
} as const;

export type PaletteToken = keyof typeof palette;

/** Escala Mantine (0 = claro, 6 = base, 9 = oscuro) */
export const mantineColors = {
  slate: [
    '#EEF3F4',
    '#E8F0F2',
    palette.border,
    '#B8C8CE',
    palette.primaryLight,
    '#6E8790',
    palette.primary,
    palette.primaryHover,
    '#3A4A52',
    palette.textPrimary,
  ],
  accentTeal: [
    palette.accentBg,
    palette.tint2,
    palette.tint1,
    '#A8E8E0',
    '#8FD4CC',
    palette.accent,
    palette.accentDark,
    '#3A736C',
    '#2D5A54',
    '#1E3D39',
  ],
  gray: [
    palette.surfacePage,
    '#F4F7F8',
    palette.border,
    '#C5D0D5',
    palette.textMuted,
    palette.textSecondary,
    palette.textSecondary,
    palette.primaryHover,
    '#3A4A52',
    palette.textPrimary,
  ],
  positive: [
    '#E6F4EC',
    '#C8E8D4',
    '#9DD4B0',
    '#6FC08F',
    palette.chartPositiveMeta,
    '#3D9460',
    palette.positive,
    '#156038',
    '#104A2B',
    '#0A321D',
  ],
  negative: [
    '#FDECEA',
    '#F5C6C1',
    '#EAA29A',
    '#DC7A6F',
    '#D05A4D',
    '#C0392B',
    palette.negative,
    '#9B2E23',
    '#7A241C',
    '#5C1B15',
  ],
  warning: [
    '#FEF3E2',
    '#FCE4BC',
    '#F5CF8A',
    '#E8B55A',
    '#D4860A',
    palette.warning,
    '#B87208',
    '#945D06',
    '#704805',
    '#4D3103',
  ],
} as const;
